export default __webpack_public_path__ + "static/media/tax-assist-functions.c07b589a.png";